var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.117,
    height: 58.347,
    viewBox: "0 0 76.117 58.347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.246 -31.604)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.246 31.604)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.528,31.6,173.272,43.876a6.053,6.053,0,0,0-3.026,5.242v5.04L191.823,41.7A7.391,7.391,0,0,0,194.528,31.6Z",
    transform: "translate(-170.246 -31.604)",
    fill: "#f79219"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.528,31.6l-1.445.834a7.393,7.393,0,0,1-3.327,8.708L170.247,52.41v1.747L191.824,41.7A7.391,7.391,0,0,0,194.528,31.6Z",
    transform: "translate(-170.247 -31.604)",
    fill: "#ef7816"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.979,64.664,170.246,77.212v8.534L189.273,74.76A7.391,7.391,0,0,0,191.979,64.664Z",
    transform: "translate(-170.246 -64.664)",
    fill: "#ffa91a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.979,64.664l-1.445.834a7.393,7.393,0,0,1-3.327,8.707L170.246,84v1.747L189.273,74.76A7.39,7.39,0,0,0,191.979,64.664Z",
    transform: "translate(-170.246 -64.664)",
    fill: "#f79219"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19.942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.549,97.5l-19.3,11.145v8.534l16.6-9.583a7.39,7.39,0,0,0,2.705-10.1Z",
    transform: "translate(-170.246 -97.497)",
    fill: "#ffc91d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19.942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.549,97.5l-1.445.834a7.393,7.393,0,0,1-3.327,8.708l-14.531,8.39v1.747l16.6-9.583a7.391,7.391,0,0,0,2.705-10.1Z",
    transform: "translate(-170.246 -97.497)",
    fill: "#ffa91a"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.238,31.6,24.493,43.876a6.053,6.053,0,0,1,3.026,5.242v5.04L5.943,41.7A7.391,7.391,0,0,1,3.238,31.6Z",
    transform: "translate(-2.246 -31.604)",
    fill: "#f79219"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.238,31.6l1.445.834A7.393,7.393,0,0,0,8.01,41.146L27.519,52.41v1.747L5.943,41.7A7.391,7.391,0,0,1,3.238,31.6Z",
    transform: "translate(-2.246 -31.604)",
    fill: "#ef7816"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.549 10.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.659,64.664,33.392,77.212v8.534L14.364,74.76a7.391,7.391,0,0,1-2.705-10.1Z",
    transform: "translate(-10.668 -64.664)",
    fill: "#ffa91a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.549 10.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.659,64.664,13.1,65.5a7.393,7.393,0,0,0,3.327,8.707L33.392,84v1.747L14.364,74.76a7.391,7.391,0,0,1-2.705-10.1Z",
    transform: "translate(-10.668 -64.664)",
    fill: "#f79219"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.978 19.942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.686,97.5l19.3,11.145v8.534l-16.6-9.583a7.39,7.39,0,0,1-2.705-10.1Z",
    transform: "translate(-18.695 -97.497)",
    fill: "#ffc91d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.978 19.942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.686,97.5l1.445.834a7.393,7.393,0,0,0,3.327,8.708l14.531,8.39v1.747l-16.6-9.583a7.39,7.39,0,0,1-2.705-10.1Z",
    transform: "translate(-18.695 -97.497)",
    fill: "#ffa91a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.143 3.852)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.949,139.891H91.882A9.834,9.834,0,0,0,98.87,137c2.784-2.809,4.461-6.783,4.461-11.982,0-8.12-7.091-17.088-12.84-21.8H78.457C72.721,107.933,65.5,116.9,65.5,125.021c0,5.2,1.678,9.172,4.461,11.982a9.831,9.831,0,0,0,6.988,2.889Z",
    transform: "translate(-65.5 -103.218)",
    fill: "#075965"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.668 21.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.618,130.161a.606.606,0,0,1-.587-.753c1-3.994,3.614-8.51,7.35-12.716a.605.605,0,1,1,.9.8c-3.609,4.064-6.124,8.4-7.081,12.207a.606.606,0,0,1-.587.458Zm8.873-14.227a.605.605,0,0,1-.431-1.03l.035-.035a.605.605,0,0,1,.856.856l-.029.029A.6.6,0,0,1,80.49,115.934Z",
    transform: "translate(-71.012 -114.691)",
    fill: "#5e9cf7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.973 18.981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.683,107.052c4.444,4.9,8.47,11.5,8.47,17.616,0,5.2-1.677,9.172-4.461,11.982a9.832,9.832,0,0,1-6.988,2.889H80.772a9.89,9.89,0,0,1-5.45-1.63,14.434,14.434,0,0,0,1.488,1.767,9.832,9.832,0,0,0,6.988,2.889H98.731a9.833,9.833,0,0,0,6.988-2.889c2.784-2.809,4.461-6.783,4.461-11.982C110.18,120.2,104.135,111.98,98.683,107.052Z",
    transform: "translate(-75.322 -107.052)",
    fill: "#0d9aaf"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.716 19.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.15,109.361c4.733,4.965,9.229,11.966,9.229,18.43,0,5.2-1.677,9.172-4.461,11.982a9.832,9.832,0,0,1-6.988,2.889H84a9.863,9.863,0,0,1-6.22-2.2c.24.282.486.557.745.819a9.832,9.832,0,0,0,6.988,2.889h14.933a9.833,9.833,0,0,0,6.988-2.889c2.784-2.809,4.461-6.783,4.461-11.982C111.892,122.152,106.39,114.343,101.15,109.361Z",
    transform: "translate(-77.778 -109.361)",
    fill: "#0f7989"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.675 24.882)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.231,150.788h-3.22a4.635,4.635,0,0,1-4.63-4.63.605.605,0,1,1,1.211,0,3.424,3.424,0,0,0,3.42,3.42h3.22a3.424,3.424,0,0,0,3.42-3.42v-1.61a3.424,3.424,0,0,0-3.42-3.42h-3.22a4.63,4.63,0,0,1,0-9.26h3.22a4.635,4.635,0,0,1,4.63,4.63.605.605,0,1,1-1.211,0,3.424,3.424,0,0,0-3.42-3.42h-3.22a3.42,3.42,0,0,0,0,6.839h3.22a4.635,4.635,0,0,1,4.63,4.63v1.61A4.635,4.635,0,0,1,115.231,150.788Z",
    transform: "translate(-107.381 -131.868)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.605,148.687a.606.606,0,0,1-.605-.605V127.153a.605.605,0,1,1,1.211,0v20.929A.605.605,0,0,1,126.605,148.687Z",
    transform: "translate(-126 -126.548)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.457,58.307H93.6a7.226,7.226,0,0,0-1.384-4.314c-2.156-2.707-6.393-5.795-4.449-7.643,2.266-2.155,4.634,2.017,7.048,2.017s1.183-4.033,4.715-4.033,2.787,4.033,4.715,4.033,5.094-4.188,7.049-2.017c2.268,2.521-2.147,4.973-4.275,7.643A9.95,9.95,0,0,0,105.457,58.307Z",
    transform: "translate(-87.266 -44.333)",
    fill: "#075965"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.752 1.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.234,49.558c-.864-.96-1.964-.677-3.09-.063.021.021.043.04.063.063,2.268,2.521-2.147,4.973-4.275,7.643a9.946,9.946,0,0,0-1.558,4.314H140.4a9.945,9.945,0,0,1,1.558-4.314C144.087,54.531,148.5,52.079,146.234,49.558Z",
    transform: "translate(-137.374 -48.934)",
    fill: "#0d9aaf"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.265 1.393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.721,49.56a1.87,1.87,0,0,0-2.158-.479,1.9,1.9,0,0,1,.645.479c2.268,2.521-2.147,4.973-4.275,7.643a9.946,9.946,0,0,0-1.558,4.314h1.513a9.945,9.945,0,0,1,1.558-4.314C147.574,54.533,151.989,52.08,149.721,49.56Z",
    transform: "translate(-142.374 -48.936)",
    fill: "#0f7989"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.568 13.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.189,94.353H102.342a1.924,1.924,0,0,1,0-3.847h12.847a1.924,1.924,0,0,1,0,3.847Z",
    transform: "translate(-100.418 -90.506)",
    fill: "#58595b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.605 14.011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.648,90.628a1.922,1.922,0,0,1-1.887,2.3H100.913a1.925,1.925,0,0,1-.373-.037,1.924,1.924,0,0,0,1.887,1.55h12.847a1.923,1.923,0,0,0,.373-3.81Z",
    transform: "translate(-100.54 -90.628)",
    fill: "#414042"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.0b637285a3b27b205b2abb2682026abb.svg";
export { ForwardRef as ReactComponent };